export const VNOTP_SET_CACHED_PAYMENT_INFO = 'VNOTP_SET_CACHED_PAYMENT_INFO'
export const VNOTP_SET_SHIFT4_TOKENIZATION = 'VNOTP_SET_SHIFT4_TOKENIZATION'
